import { useState, useEffect } from "react";
import * as XLSX from "xlsx";

export const useExcelParser = (file) => {
  const [excelData, setExcelData] = useState(null);
  const [error, setError] = useState(null);
  const [parsedData, setParsedData] = useState(null);

  const REQUIRED_HEADERS = [
    "TARGA",
    "CODICE CONFIGURAZIONE",
    "DATA INIZIO COPERTURA",
    "DATA FINE COPERTURA",
    "DATA RENDICONTAZIONE",
    "COLLABORATORE",
  ];

  const formatExcelValue = (val) => {
    if (val instanceof Date && !isNaN(val)) {
      const d = val.getDate().toString().padStart(2, "0");
      const m = (val.getMonth() + 1).toString().padStart(2, "0");
      const y = val.getFullYear();
      return `${d}/${m}/${y}`;
    }
    return val;
  };

  useEffect(() => {
    if (file) {
      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const binaryStr = event.target.result;
          const workbook = XLSX.read(binaryStr, {
            type: "binary",
            cellDates: true,
          });

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            raw: true,
          });

          if (json.length === 0) {
            setError("Il file Excel è vuoto");
            return;
          }

          const headers = json[0].map((h) =>
            h ? h.toString().trim().toUpperCase() : ""
          );
          const headerMap = {};

          REQUIRED_HEADERS.forEach((req) => {
            const index = headers.indexOf(req.toUpperCase());
            if (index !== -1) {
              headerMap[req] = index;
            }
          });

          const missingHeaders = REQUIRED_HEADERS.filter(
            (h) => headerMap[h] === undefined
          );

          if (missingHeaders.length > 0) {
            setError(`Intestazioni mancanti: ${missingHeaders.join(", ")}`);
            setParsedData(null);
            return;
          }

          const dataRows = json.slice(1).map((row, index) => {
            const rowData = { id: index + 1 };
            REQUIRED_HEADERS.forEach((h) => {
              const rawValue = row[headerMap[h]];
              rowData[h] = formatExcelValue(rawValue);
            });
            return rowData;
          });

          setParsedData(dataRows);
          setError(null);

          // Keep excelData for backward compatibility if needed, though we might remove it
          setExcelData([{ name: firstSheetName, data: worksheet }]);
        } catch (err) {
          setError("Errore nel parsing del file Excel");
        }
      };

      reader.onerror = () => {
        setError("Errore nella lettura del file");
      };

      reader.readAsBinaryString(file);
    }
  }, [file]);

  return { excelData, parsedData, error };
};
